import { useTheme } from "@mui/material/styles";

export const useStyles = () => {
  const theme = useTheme();

  return {
    horizontalBar: {
      top: 71,
      bgcolor: theme.palette.background.default,
      width: "100%",
      height: 62,
      justifyContent: "center",
      borderTop: `1px solid ${theme.palette.divider}`,
      zIndex: 1098,
    },
    menuListWrapper: {
      display: "flex",
      alignItems: "center",
    },
  };
};
